export default "__VITE_ASSET__9449ab4c__"